module.exports = __webpack_public_path__ + "static/media/bano.341c6924.jpg";